import '../scss/style.scss';
import '../js/rating.js';

console.log('Parcel is working. Hurray!');